module.exports = __webpack_public_path__ + "img/sheet-8-11-3.287ca19c.png";